// extracted by mini-css-extract-plugin
module.exports = {"tips-box":"tips-box--ouE7o"};